import { withUnmountTransition } from '../../../../../misc/withUnmountTransition.hoc'
import { CpsPincodeModal } from './CpsPincodeModal.component'

const withUnmountHoc = withUnmountTransition(CpsPincodeModal)
export { withUnmountHoc as CpsPincodeModal }
